import type { GetDynamicInvoiceDataResponse } from '@vy/api-definition';
import { validateNotNullOrUndefined } from '@vy/utils';
import type { PropsWithChildren } from 'react';
import React, { createContext, useContext } from 'react';

export const DynamicInvoiceContext = createContext<GetDynamicInvoiceDataResponse | undefined>(undefined);

export function useDynamicInvoice() {
  const dynamicInvoice = useContext(DynamicInvoiceContext);

  validateNotNullOrUndefined(
    dynamicInvoice,
    'useDynamicInvoice must be used within DynamicInvoiceContextProvider',
  );

  return dynamicInvoice;
}

type DynamicInvoiceContextProviderProps = {
  dynamicInvoiceDataResponse: GetDynamicInvoiceDataResponse;
};

export const DynamicInvoiceContextProvider: React.FC<
  PropsWithChildren<DynamicInvoiceContextProviderProps>
> = ({ dynamicInvoiceDataResponse, children }) => {
  return (
    <DynamicInvoiceContext.Provider value={dynamicInvoiceDataResponse}>
      {children}
    </DynamicInvoiceContext.Provider>
  );
};
